import React from 'react';
import { ResponsivePie } from '@nivo/pie';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarCheck, faTicket } from "@fortawesome/free-solid-svg-icons";

const TotalEvents = ({totalEventCreated}) => {
  // const newUsersToday = 120;
  // const newUsersYesterday = 0;


  // const data = [
  //   { id: 'Today', value: newUsersToday },
  // ];

 var colors = ['#61cdbb', '#61cdbb'] 

  const difference = totalEventCreated.EventsCreatedToday - totalEventCreated.EventsCreatedYesterday;

  let data;
  if (difference < 0) {
    data = [
      { id: 'Yesterday', value: totalEventCreated.EventsCreatedYesterday - totalEventCreated.EventsCreatedToday },
      { id: 'Today', value: totalEventCreated.EventsCreatedToday },
    ];
  } else {
    data = [
      { id: 'Yesterday', value: totalEventCreated.EventsCreatedToday -totalEventCreated.EventsCreatedYesterday   },
      { id: 'Today', value: totalEventCreated.EventsCreatedYesterday },
    ];
  }

  if (difference === 0) {
    data = [
      { id: 'Yesterday', value: 100 },
      { id: 'Today', value: 0 },
    ];
  } 



  return (
    <div style={{display:"flex", justifyContent:"space-around"}}>
         <div style={{width:"30%",marginTop:"1em"}}>
         <FontAwesomeIcon style={{width:"20%"}}  icon={faCalendarCheck} />
            <h3>Total<br></br> Events</h3>
            </div>
         
    
            <div>
       
       </div>

<div style={{ height: "10vh", width: "30%", marginTop: "1em" }}>
        <div class="pie-chart" style={{backgroundColor:"#61cdbb"}}>
          <div class="inner-circle">
         <h3>{totalEventCreated.totalEvents} </h3>
          </div>
        </div>
      </div>


     
    </div>
     
  );
};

export default TotalEvents;
